export const projectsAll = [
    // thesis 1 
    {
        live: "",
        title: "Data Science",
        video_key: "HvkrAjHJ-46",
        category: "data-science",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",

        about_this_app:
            "Smart asset tracking and optimization",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/thesis/img1.jpg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "https://github.com/Hazrat-Ali9",
        frontend_dowload_link:
            "https:",
        backend_dowload_link: "",
        project_image: "/images/project-10.png",
        project_blog:
            "Smart asset tracking and optimization.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 2
    {
        live: "",
        title: "Machine Learning",
        video_key: "HvkrAjHJ-46",
        category: "machine-learning",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        about_this_app:
            "Secure and efficient banking operations.",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [

        ],
        image: "/thesis/img2.jpg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "",
        frontend_dowload_link:
            "",
        backend_dowload_link: "",
        project_image: "/0845485.jpeg",
        project_blog:
            "Secure and efficient banking operations.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 3
    {
        live: "Artificial intelligence",
        title: "Artificial intelligence",
        video_key: "HvkrAjHJ-46",
        category: "artificial-intelligence",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        about_this_app:
            "Streamlined collaboration and productivity in one place.",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "Html",
            "Tailwind",
            "Typescript",
            "Javascript",
            "Redux"
        ],
        image: "/thesis/img3.jpg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "",
        frontend_dowload_link:
            "https:",
        backend_dowload_link: "",
        project_image: "/images/project-13.png",
        project_blog:
            "Streamlined collaboration and productivity in one place.",
        Type: "Reactjs",
        indevelopment: false,
    },
    //Project 4
    {
        title: "Software Engineering",
        category: "software-engineering",
        video_key: "HvkrAjHJ-38",
        say_xi: "Xi Have a Gread Day ☘️ ",
        say_xi_blog:
            "This is My Profiol Project For Showcase , basic Ui interface and Contain Basic Animation & Authentication  ",
        about_this_app:
            "Contain StarMode , Drop Down NavBar , Authentication Google , Facebook , Github , Instgram , Custom Star Colour Basic Animation ",
        design_blog: " Ui/Ux Desing & All Code Written by Me  ",
        dependencies_blog:
            "You can use Yarn or NPM to install the dependencies. In this case I am use NPM",
        package: [
            "@heroicons/react",
            "@reduxjs/toolkit",
            "@tailwindcss/line-clamp",
            "autoprefixer",
            "eslint",
            "eslint-config-next",
            "next",
            "next-auth",
            "next-redux-wrapper",
            "postcss",
            "react",
            "react-dom",
            "react-loader-spinner",
            "react-loading-skeleton",
            "react-onclickoutside",
            "react-redux",
            "tailwindcss"
        ],
        image: "/thesis/img4.jpg",
        conclusion_blog: "",
        youtube_link: "",
        githhub_link: "",
        frontend_dowload_link:
            "",
        backend_dowload_link: "",
        live: "",
        project_image: "/images/project-1.png",
        project_blog:
            "Customize and build your perfect PC effortlessly.",
        Type: "React js",
        indevelopment: false,
    },
  
];

export const clientReviews = [
    {
        user: {
            name: "John Doe",
            avatar: ""
        },
        text: "I was extremely satisfied with the service provided. Highly recommended!"
    },
    {
        user: {
            name: "Jane Smith",
            avatar: ""
        },
        text: "Outstanding customer support and quick response times. A+ service!"
    },
    {
        user: {
            name: "Michael Johnson",
            avatar: ""
        },
        text: "The product exceeded my expectations. Great quality and value."
    },
    {
        user: {
            name: "Sarah Brown",
            avatar: ""
        },
        text: "I'm a happy customer. The team went above and beyond to assist me."
    },
    {
        user: {
            name: "",
            avatar: ""
        },
        text: "Prompt delivery and excellent communication. Will buy again!"
    },
    {
        user: {
            name: "Emily Davis",
            avatar: ""
        },
        text: "The service was exceptional. I'm impressed with the professionalism."
    },
    {
        user: {
            name: "Robert Lee",
            avatar: ""
        },
        text: "I had a wonderful experience. Great product and support."
    },
    {
        user: {
            name: "Amanda Garcia",
            avatar: ""
        },
        text: "Top-notch service that I would recommend to anyone."
    },
    {
        user: {
            name: "William Clark",
            avatar: ""
        },
        text: "Reliable and trustworthy. I'm a satisfied and loyal customer."
    },
    {
        user: {
            name: "Laura White",
            avatar: ""
        },
        text: "Couldn't be happier with the product quality and customer care."
    }
];

